import React, { createContext, useEffect, useLayoutEffect, useState } from "react";
import Storage from 'util/store/Storage'

export const EmpresasContext = createContext({} as any)
export const EmpresasSelectProvider = ({ children }: any) => {
    const { empresasHijos, usuario } = Storage.getState()
    const [empresa, setEmpresa] = useState(empresasHijos);

    useEffect(() => {
        if(!empresasHijos) return
        setEmpresa(Number(empresasHijos))
    }, [empresasHijos]);

    return (
        <EmpresasContext.Provider value={{
            empresa, setEmpresa,
        }}>
            {children}
        </EmpresasContext.Provider>
    )

}